import { CardContainer, FormLayout } from '@/_containers';
import { RichTextLoader } from '@/_containers/inputs/rich-text';

export default function Loading() {
  return (
    <CardContainer>
      <FormLayout>
        <RichTextLoader className="col-span-12" withLabel />
        <RichTextLoader className="col-span-12" withLabel />
      </FormLayout>
    </CardContainer>
  );
}
